import React from 'react';

const PrevButton = ({ onClickFunc, disabled = false, word = '戻る' }) => (
  <button
    type="button"
    className="col-5 a-button a-button__top a-button__top--outline mb-5"
    onClick={onClickFunc}
    disabled={disabled}
  >
    {word}
  </button>
);

export default PrevButton;
